import { fetchAuthSession } from 'aws-amplify/auth';

export async function refreshAuthorizationHeader(): Promise<string> {
  try {
    // this method will automatically refresh the accessToken and idToken if tokens are expired and a valid refreshToken presented
    const session = await fetchAuthSession();
    const authHeaderValue = `Bearer ${session.tokens?.accessToken.toString()}`;
    return authHeaderValue;
  } catch (error) {
    // eslint-disable-next-line no-console -- maybe useful for debugging
    console.error(error);
    return Promise.reject(error);
  }
}
